<template>
  <menu-item label="" tooltip-key="tooltip_cooler" v-if="tank.cooler_id">
    <custom-checkbox
        v-model="cooler"
        :label="$t('powerpack.valveMenu.cooler')"
    ></custom-checkbox>
  </menu-item>
</template>

<script>
  import MenuItem from './MenuItem'
  import CustomCheckbox from "@/components/input/Checkbox";
  import {mapGetters, mapState} from "vuex";

  export default {
    name: 'CoolerCheckbox',

    components: {
      MenuItem,
      CustomCheckbox,
    },

    computed: {
      ...mapGetters({
        tank: 'build/getTank',
      }),
      ...mapState('build', {
        hasCooler: (state) => state.cooler,
      }),
      cooler: {
        get() {
          return this.hasCooler;
        },
        set(val) {
          this.$store.commit('build/setCooler', val)
        }
      },
    },
  }
</script>
